module.exports = __webpack_public_path__ + "static/media/Graphic4.fbfb17b9.png";